import { SharedApplicationConstants } from '@ddt-web/domain';
import { UrlUtils } from '@ddt-web/url';

export class ImagePathUtil {
	public static getImagePath(imageName: string): string {
		let rootPath = window['ASSET_PREFIX_PATH'];
		if (UrlUtils.isLocalhost()) {
			rootPath = 'https://testc.blackrock.com/blk-one-c-assets';
		} else if (UrlUtils.isInternalHost()) {
			rootPath = 'https://www.blackrock.com/blk-one-c-assets';
		}

		const imagePath = rootPath + SharedApplicationConstants.IMAGE_REMOTE_PATH;
		const fullPath = UrlUtils.removeDuplicateSlashes(imagePath + imageName);
		return fullPath;
	}
}
